function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useCarousel } from "../components/CarouselContext";
var SlideContext = createContext({
    setSlideActive: function() {},
    distanceFromFullyVisible: 0,
    distanceFromVisible: 0,
    index: 0,
    slideLabel: '',
    setSlideLabel: function() {}
});
var calculateDistanceFromVisible = function(param) {
    var index = param.index, slideIndex = param.slideIndex, cols = param.cols, showOverhang = param.showOverhang;
    var distanceFromActive = index - slideIndex;
    if (distanceFromActive > 0) {
        var overhangAddition = showOverhang ? -1 : 0;
        return Math.max(0, distanceFromActive - ((cols || 0) - 1) + overhangAddition);
    }
    var overhangAddition1 = showOverhang ? 1 : 0;
    return Math.min(distanceFromActive + overhangAddition1, 0);
};
export var SlideProvider = function(param) {
    var index = param.index, children = param.children, sliderRef = param.sliderRef;
    var ref = useCarousel(), _actions = ref.actions, setSlideIndex = _actions.setSlideIndex, setSlideLabels = _actions.setSlideLabels, _state = ref.state, slideIndex = _state.slideIndex, cols = _state.cols, slideCount = _state.slideCount, showOverhang = _state.showOverhang;
    var ref1 = _slicedToArray(useState(''), 2), slideLabel = ref1[0], setSlideLabel = ref1[1];
    useEffect(function() {
        setSlideLabels({
            label: slideLabel,
            index: index
        });
    }, [
        slideCount,
        setSlideLabels,
        index,
        slideLabel
    ]);
    var ref2 = _slicedToArray(useState(function() {
        return calculateDistanceFromVisible({
            index: index,
            slideIndex: slideIndex,
            cols: cols,
            showOverhang: showOverhang
        });
    }), 2), distanceFromVisible = ref2[0], setDistanceFromVisible = ref2[1];
    var ref3 = _slicedToArray(useState(function() {
        return calculateDistanceFromVisible({
            index: index,
            slideIndex: slideIndex,
            cols: cols,
            showOverhang: false
        });
    }), 2), distanceFromFullyVisible = ref3[0], setDistanceFromFullyVisible = ref3[1];
    useEffect(function() {
        setDistanceFromVisible(calculateDistanceFromVisible({
            index: index,
            slideIndex: slideIndex,
            cols: cols,
            showOverhang: showOverhang
        }));
        setDistanceFromFullyVisible(calculateDistanceFromVisible({
            index: index,
            slideIndex: slideIndex,
            cols: cols,
            showOverhang: false
        }));
    }, [
        index,
        slideIndex,
        cols,
        showOverhang
    ]);
    var setSlideActive = useCallback(function() {
        var slider = sliderRef.current;
        if (slider) {
            slider.scrollLeft = 0;
        }
        setSlideIndex(Math.min(index, slideCount - (cols || 0)));
    }, [
        index,
        setSlideIndex,
        cols,
        slideCount,
        sliderRef
    ]);
    return _jsx(SlideContext.Provider, {
        value: {
            setSlideActive: setSlideActive,
            distanceFromVisible: distanceFromVisible,
            distanceFromFullyVisible: distanceFromFullyVisible,
            index: index,
            slideLabel: slideLabel,
            setSlideLabel: setSlideLabel
        },
        children: children
    });
};
export var useSlideLabel = function(label, dependencies) {
    var setSlideLabel = useContext(SlideContext).setSlideLabel;
    useEffect(function() {
        setSlideLabel(label);
    }, dependencies);
};
export var useSlide = function() {
    return useContext(SlideContext);
};
